import { Braces } from "lucide-react";
import React, { FC } from "react";
import { useImmer } from "use-immer";

import { IgDivider, IgIconButton, IgTypography } from "@intelligems/ig-theme";
import { ComponentSettingsVariables } from "@intelligems/ig-widgets/ProgressBarView/util/textVariables";
import { Grid, ListSubheader, Menu, MenuItem, useTheme } from "@mui/material";
import { fromMentionsVariables } from "@src/features/personalizations/components/offerModifications/userInterfaces/utils";

function groupByCategory(variables: ComponentSettingsVariables[]) {
  return variables.reduce((acc, item) => {
    const category = item.category;

    if (!acc[category]) {
      acc[category] = [];
    }

    acc[category].push(item);

    return acc;
  }, {});
}

interface ExternalVariableTextInputMenuProps {
  variables: ComponentSettingsVariables[];
  formatted: string;
  onChange: (value: string, variables: ComponentSettingsVariables[]) => void;
}

export const ExternalVariableTextInputMenu = ({
  variables,
  onChange,
  formatted,
}: ExternalVariableTextInputMenuProps) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useImmer<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };

  const transformedVariables = groupByCategory(variables);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  return (
    <Grid item>
      <IgIconButton onClick={handleClick}>
        <Braces size={16} />
      </IgIconButton>

      <Menu onClose={handleClose} open={open} anchorEl={anchorEl}>
        {Object.entries(transformedVariables).map(
          (
            [category, items]: [string, ComponentSettingsVariables[]],
            index
          ) => (
            <div key={category}>
              {index !== 0 && <IgDivider />}
              <ListSubheader
                sx={{
                  padding: "6px 16px",
                  lineHeight: "0px !important",
                  backgroundColor:
                    theme.igBackgroundColors.interactive.neutral.default,
                }}
              >
                <IgTypography fontWeight={600}>{category}</IgTypography>
              </ListSubheader>
              {items.map((item) => (
                <MenuItem
                  key={item.id}
                  onClick={() =>
                    onChange(
                      `${fromMentionsVariables(formatted, variables)} #${item.id}`,
                      variables
                    )
                  }
                >
                  {item.display}
                </MenuItem>
              ))}
            </div>
          )
        )}
      </Menu>
    </Grid>
  );
};
